module.exports = __webpack_public_path__ + "static/media/carroussel_2.19b1a090.png";